module.exports = __webpack_public_path__ + "static/media/not_available.36b23e4e.png";